import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { ThemeService } from '../_helpers/theming-engine/theme.service';
import { AlertService, UserService, AuthenticationService } from '../_services/index';
import { SuccessModalHelperService } from '../_helpers/success-modal-helper/success-modal-helper.service';

@Component({
    templateUrl: 'reset-password.component.html',
    styleUrls: ['reset-password.component.css'],
    standalone: false
})

export class ResetpasswordComponent implements OnInit {
  frmSignup: UntypedFormGroup;
  submitted = false

  public btnDisabled: boolean = false; // TODO: this property wasn't declared
  constructor(
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private userService: UserService,
    private successModalHelper: SuccessModalHelperService,
    public themeService: ThemeService,
    private errorModalHelper: ErrorModalHelperService
    ) { }

  get f() { return this.frmSignup.controls; }

  ngOnInit() {
    this.themeService.setActiveTheme('LEAP', false);

    //this.btnDisabled = false;
    this.frmSignup = this.formBuilder.group({
      email: [null, Validators.compose([Validators.email, Validators.required])
      ]
    })
  }

  sendPasswordLink() {
    this.submitted = true;

    if (!this.frmSignup.valid) {
      return;
    }


    this.userService.sendpasswordlink(this.frmSignup.value.email).subscribe(
      data => {
    
        this.successModalHelper.show('If the email is correct a password reset link will be sent to the email address provided');
      
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      },
      error => {
        
        this.errorModalHelper.show(error.message, error);
      }
    )
  }
}
